import { gql, type TypedDocumentNode } from "@apollo/client";

export type FacilityEmployment = {
  id: string;
  title: string;
  formattedTitle: string | null;
  jobClassification: string;
  startedOn: string | null;
  person: {
    id: string;
    firstName: string;
    lastName: string;
    displayName: string;
    profilePhoto?: string;
    pgaId: string | null;
    latestProgram: {
      id: string;
      status: string;
      programType: {
        id: string;
        name: string;
      };
      band?: {
        terminatedReason?: string | null;
        terminatesOn?: string | null;
      } | null;
    } | null;
  };
};

export type FacilityEmployeesQueryResponse = {
  facility: {
    id: string;
    name: string;
    employments: {
      nodes: FacilityEmployment[];
    };
  };
};

export interface FacilityEmployeesQueryVariables {
  facilityId: string;
}

export const FACILITY_EMPLOYEES_QUERY: TypedDocumentNode<
  FacilityEmployeesQueryResponse,
  FacilityEmployeesQueryVariables
> = gql`
  query FacilityEmployees($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      name
      employments(orderBy: JOB_CLASSIFICATION_RANK_ASC, active: true) {
        nodes {
          id
          title
          formattedTitle
          jobClassification
          startedOn
          person {
            id
            firstName
            lastName
            displayName
            profilePhoto
            pgaId
            latestProgram {
              id
              status
              programType {
                id
                name
              }
              band {
                terminatedReason
                terminatesOn
              }
            }
          }
        }
      }
    }
  }
`;
